import angular from 'angular'

import clientService from 'common/client.service'
import playerApiService from 'common/player-api.service'
import offlineScheduleService from 'common/offline-schedule.service.js'

import playerFactory from 'components/player-factory'

import component from './player.component'

export default angular.module('player', [
  clientService,
  playerApiService,
  offlineScheduleService,
  playerFactory
])
  .directive('player', component)
  .name
